"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFastForwardOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.fast-forward_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "fast-forward_outline_svg__transparent_box" },
            React.createElement("path", { className: "fast-forward_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "fast-forward_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("path", { d: "M32.11 16L16 7.33v8.06L1 7.33v17.34l15-8.07v8.07zM18 10.67L27.89 16 18 21.33zM3 21.33V10.67L12.9 16z", id: "fast-forward_outline_svg__OUTLINE" })));
}
exports.default = SvgFastForwardOutline;
//# sourceMappingURL=FastForwardOutline.js.map